export function noop(..._args: unknown[]): void {}
